import type { PlaygroundSbt } from '../types.js';

export type PlaygroundSbtState = {
  loaded: boolean;
  data: PlaygroundSbt | null;
};

const initialState = {
  loaded: false,
  data: null,
} as PlaygroundSbtState;

export default initialState;
